import meetingState from '../data/constants/meetingState';

export default function getUserFromMeetingInvite(invite, i18n) {
    let user;
    if (!invite.anonymous || invite.state == meetingState.CONFIRMED) {
        user = invite.user;
    } else {
        user = {
            first_name: i18n['label.Anonymous'],
            last_name: '',
            image_url: 'img/no_avatar.png',
        };
    }
    return Object.assign({}, user, { state: invite.state });
}
